import { GridCellParams } from '@mui/x-data-grid'

import { Text } from '@mxenabled/mxui'

import { DATE_FORMATS_INTL, formatDate } from '../../../../../core/constants'
import { fromUnixUTC } from '../../../../../core/utils/DateUtil'

const DateCell = (params: GridCellParams) => {
  return (
    <Text tabIndex={params.tabIndex} variant="body2">
      {formatDate(fromUnixUTC(params.row.date), DATE_FORMATS_INTL.MONTH_DAY)}
    </Text>
  )
}

export default DateCell
